export enum Flipper {
  rt_ipp_customer_admin_view = 'rt_ipp_customer_admin_view',
}
